<template>
  <div id="caijixiangqing">
    <van-sticky>
      <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    </van-sticky>

    <div class="xinxi">
      <div style="margin-bottom: 0.3rem">
        <div style="display: flex; justify-content: space-between">
          <div class="twoTitle" style="width: 1.7rem">任务名称：</div>
          <div style="display: flex; justify-content: space-between; width: calc(100% - 1.7rem)">
            <div class="twoLine">{{ taskName }}</div>
            <div
              class="text-box"
              :style="{
                color:
                  rightText.indexOf('已上报') > -1
                    ? 'green'
                    : rightText.indexOf('退回') > -1
                    ? 'red'
                    : rightText.indexOf('待审核') > -1
                    ? 'blue'
                    : 'red'
              }"
            >
              {{ rightText }}
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="4.5" class="twoTitle">采集地点：</van-col>
          <van-col span="19" class="twoLine">{{ stationName }}</van-col>
        </van-row>
      </div>
      <div>
        <van-row>
          <van-col span="4.5" class="twoTitle">期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</van-col>
          <van-col span="7" class="twoLine">
            {{ exeno }}
          </van-col>
          <van-col span="4.5" class="twoTitle">截止时间：</van-col>
          <van-col span="7" class="twoLine" style="color: red">{{ priceDate }} {{ lateReportTime }}</van-col>
        </van-row>
      </div>
    </div>

    <!-- 商品表格 -->
    <comList ref="listRef" :list="list" @handItemCLick="clickStoreName" :saveState="dis" :computeSetList="computeSetList" :computeNeed="computeNeed" :goodsInfosNeed="goodsInfosNeed"></comList>

    <!-- 按钮 -->
    <div class="bottom">
      <div style="display: flex; box-shadow: 0px -1px 10px #0000004d; height: 100%; align-items: center">
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center; flex: 1; position: relative">
          <v-button class="btn1" @click="save">保存</v-button>
        </div>
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center; flex: 1; position: relative">
          <v-button class="btn1" @click="shangbao">上报</v-button>
        </div>
        <div offset="1" style="text-align: center; flex: 1; position: relative">
          <v-button class="btn1 btn2" @click="chaKanRiZhi">查看日志</v-button>
        </div>
      </div>
    </div>

    <!-- 商品详细信息弹窗 -->
    <detailDialog ref="detailRef" :saveState="dis" @saveBasic="saveBasic" :taskConfig="taskConfig" :levelNum="levelNum"></detailDialog>

    <!-- 查看日志弹窗 -->
    <logDialog ref="logRef" :logList="logList"></logDialog>
  </div>
</template>
<script>
import { loading } from '@/common/loading';
import detailDialog from '@/components/detailDialog';
import logDialog from '@/components/logDialog';
import comList from '@/components/comList';
import rulesInfoDeal from '@/utils/dataRules.js';
import { dataGrid, saveRow, upOK, getDateRecord, checkLogin } from '@/api/baseMsgtb';
import validRange from '@/utils/validRange.js';
import { Toast } from 'vant';
import { calculateListDataChange } from '@/utils/formulaCalculation.js';
export default {
  name: 'caijixiangqing',
  components: {
    detailDialog,
    logDialog,
    comList
  },
  data() {
    return {
      title: '价格采集',
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      code: this.$route.query.code,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      StationCode: this.$route.query.StationCode,
      RegionCode: this.$route.query.RegionCode,
      taskID: this.$route.query.taskId,
      shopId: this.$route.query.shopId,
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      active2: this.$route.query.active2, //0当日任务 1全部任务
      priceDate: this.$route.query.priceDate,
      lateReportTime: this.$route.query.lateReportTime,
      cjTime: new Date(), //采集日期
      dis: true, //审核状态的事项不可提交
      //
      showDetial: false, //展示商品说明
      shopIndex: '',
      shopName: '', //商品名称
      bqPrice: '', //本期价格
      bqPriceSave: '',
      contentSave: '',
      isGoods: '', //无此品种  1无，0有
      brand: '', //品牌
      ifShow: '', //为0的时候不显示 品牌文本框,1时显示
      content: '', //说明
      comments: '', //备注
      originBrand: '', //品牌产地
      originBrandShow: false,
      itemNumbersShow: false,
      itemNumbers: '', //数量
      shopIndex1: '',
      ids: [], //数据
      //
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      //===================================
      loginStatus: true,
      //
      levelNum: this.$route.query.levelNum, //用户等级
      //   xianspflag:this.$route.query.xianspflag,//用户等级

      dlrflag: this.$route.query.dlrflag, //待录入
      dsbflag: this.$route.query.dsbflag, //待上报
      ythflag: this.$route.query.ythflag, //已退回

      taskName: '', //任务名称
      stationName: '', //监测点
      rightText: '',
      msg: {
        row: {},
        form: {},
        rules: {},
        list: []
      },
      detailData: {},
      taskConfig: [],
      computeSetList: [], // 计算公式
      computeNeed: [], // 需要被计算的商品-商code数组
      goodsInfosNeed: [] // 需要被计算的商品-code数组
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    init() {
      // 初始化暂未定
      loading(true);
      this.checkLogin();
      if (this.loginStatus) {
        this.dataGrid();
      }
    },
    //houcc 2021.04.07
    dataGrid() {
      if (
        // (this.shispflag == 3 && this.levelNum=="" )||this.xianspflag == 3
        (this.dsbflag != 2 || this.ythflag != 2) &&
        this.shispflag == 3
      ) {
        //3是灰色 代表还未审核 //1蓝2绿3灰
        this.dis = false;
      } else {
        this.dis = true;
      }
      if (this.active2 == 1) {
        this.dis = true;
      }
      dataGrid({
        taskCode: this.taskCode,
        ExeNo: this.exeno,
        StationCode: this.StationCode
      }).then((result) => {
        const res = result.data.dataList;
        this.taskConfig = result.data.taskConfig;
        const columnMap = result.data.columnMapSet;
        this.rightText = result.data.stateName;
        let hbNum; //环比
        for (let i = 0; i < res.length; i++) {
          calculateListDataChange(this, result.data.computesetlist, res[i], i);
          if (columnMap[res[i].VarietyCode]) {
            const list = columnMap[res[i].VarietyCode];
            res[i].list = list;
          }
          this.taskName = res[i].taskName;
          this.stationName = res[i].stationname;
          let ringPrice = res[i].ringPrice; //上期 ringPrice
          let thisPrice = res[i].ThisPrice; //本期 ThisPrice
          if (res[i].ringIsGoods !== undefined) {
            res[i].isGoods = res[i].ringIsGoods;
          }
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == '-') {
            res[i].ThisPrice = '';
            res[i].hbNum = '-';
            continue;
          }
          let dataType = res[i].dataType; //dataType,字符类型
          if (dataType == '1003' || (!Number(ringPrice) || ringPrice == 0 || !Number(thisPrice))) {
            res[i].hbNum = '-';
            continue;
          }
          ringPrice = parseFloat(ringPrice);
          thisPrice = parseFloat(thisPrice);
          hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
          if (!Number(hbNum) && hbNum == Infinity && isNaN(hbNum)) {
            res[i].hbNum = '-';
          } else {
            if (parseInt(hbNum) > 0) {
              res[i].styleColor = 'red';
            } else if (parseInt(hbNum) < 0) {
              res[i].styleColor = 'green';
            } else {
              res[i].styleColor = 'black';
            }
            if (hbNum.toString().indexOf('.') != -1 && hbNum.toString().split('.')[1].length > 2) {
              hbNum = hbNum.toFixed(2);
            }
            res[i].hbNum = hbNum;
          }
        }
        this.list = res;
        console.log(this.list);
        loading(false);
      });
    },
    dataGrid2() {
      dataGrid({
        taskCode: this.taskCode,
        ExeNo: this.exeno,
        StationCode: this.StationCode
      }).then((result) => {
        this.rightText = result.data.stateName;
      });
    },
    //保存价格采集
    saveRow(type, editType) {
      loading(true);
      saveRow({
        taskID: this.taskID,
        taskCode: this.taskCode,
        TempCode: this.code ? this.code : '',
        ExeNo: this.exeno,
        RegionCode: this.RegionCode,
        StationCode: this.StationCode,
        shopTaskId: this.shopId,
        json: JSON.stringify(this.list),
        priceDate: this.priceDate,
        editType: editType,
      }).then((res) => {
        if (res.code == 200) {
          if (type == 1) {
            this.upOK();
            return;
          }
          loading(false);
          Toast.success(res.message);
          this.dataGrid2();
        } else {
          Toast({
            message: res.message.replace(/<\/br>/g, '\n'),
            position: 'center',
            overlay: true
          });
          Toast.setDefaultOptions({ duration: 3600 });
          setTimeout(() => {
            if (res.ids == undefined) return;
            if (res.ids != '') {
              this.ids = JSON.parse(JSON.stringify(res.ids.split(',')));
              let listIndex;
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].VarietyCode == this.ids[0]) {
                  listIndex = i;
                }
                for (let j = 0; j < this.ids.length; j++) {
                  if (this.list[i].VarietyCode == this.ids[j]) {
                    this.list[i].VarietyCodeNew = this.ids[j];
                    continue;
                  }
                }
              }
              this.clickStoreName(this.list[listIndex], listIndex);
            }
          }, 3600);
        }
      });
    },
    //上报
    upOK() {
      upOK({
        shopTaskIds: this.shopId,
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode
      }).then((res) => {
        if (res.code == 200) {
          loading(false);
          Toast.success(res.message);
          this.dis = true;
          this.dataGrid2();
        } else {
          //    this.ids = res.ids
          Toast.fail(res.message.replace(/<\/br>/g, '\n'));
        }
      });
    },
    onClickLeft() {
      this.$router.push({
        path: '/jiagecaijiTB/jiagecaiji',
        query: {
          active2: this.active2,
          startTime: this.$route.query.startTime,
          endTime: this.$route.query.endTime
        }
      });
      //   }
    },
    daoru() {
      loading(true);
      //导入上期
      for (let i = 0; i < this.list.length; i++) {
        //if (this.list[i].ringPrice == '-' || this.list[i].ringPrice == '' || this.list[i].isGoods == 1) {
        if (this.list[i].ringPrice == '-' || this.list[i].ringPrice == '') {
          continue;
        } else {
          this.list[i].isGoods = this.list[i].ringIsGoods;
          this.list[i].ThisPrice = this.list[i].ringPrice;
          if (this.list[i].ringPrice != 0) {
            this.list[i].styleColor = 'black';
            this.list[i].hbNum = 0;
          }
        }
      }
      setTimeout(() => {
        loading(false);
      }, 1000);
    },
    //判断是否复核判断条件
    ifCheckSaveRow() {
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != '' && item.dataType !== '1003') ||
            (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
            (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0))
        ) {
          Toast('数据' + item.VarietyName + '请填写波动原因说明!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
      }
      return true;
    },
    ifCheckUpOk() {
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (this.ifNullOrEmpty(item.Memo, 1)) {
          Toast('数据' + item.VarietyName + '说明的字数不能太少，至少2个文字!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != '' && item.dataType !== '1003') ||
            (item.ThisPrice == '' && item.dataType !== '1003') ||
            (item.importInfo == '' && item.dataType == '1003') ||
            (item.hbzks !== null && item.hbNum >= item.hbzks && item.hbNum > 0) ||
            (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0))
        ) {
          Toast('数据' + item.VarietyName + '请填写波动原因说明!');
          this.clickStoreName(this.list[i], i);
          return false;
        }
        let bq = item.ThisPrice;
        let sq = item.ringPrice;
        let multiPrice = item.sameNumPrice;
        let multiCount = item.sameNum;
        let multiCountTwo = item.sameNum;
        if (Number(bq) > 0 && Number(sq) > 0 && multiPrice && item.dqbb) {
          if (parseFloat(bq) === parseFloat(multiPrice)) {
            multiCountTwo = multiCountTwo + 1;
          }
          if (multiCountTwo >= item.dqbb && !item.Memo && parseFloat(bq) == parseFloat(multiPrice)) {
            Toast(`${item.VarietyName}价格${parseInt(multiCountTwo)}期不变, 请填写说明!`);
            this.clickStoreName(this.list[i], i);
            return false;
          }
        }
        let flag = true;
        if (item.list) {
          item.list.forEach((a) => {
            if ((item[a.fieldName] == '' || !item[a.fieldName]) && a.ifMust == 1 && !item.isGoods) {
              Toast('请填写' + item.VarietyName + '的商品信息!');
              this.clickStoreName(this.list[i], i);
              flag = false;
              return false;
            }
          });
          if (!flag) {
            return false;
          }
        }
      }
      return true;
    },
    ifNullOrEmpty(obj, type) {
      var regu = '^[ ]+$';
      var re = new RegExp(regu);
      if (type == 0 && (typeof obj == 'undefined' || obj == null || obj == '' || re.test(obj))) {
        return true;
      } else if (!(typeof obj == 'undefined' || obj == null || obj == '' || re.test(obj)) && obj.length < 2 && type == 1) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      //保存
      if (!this.ifCheckSaveRow()) return;
      let bool = 0;
      this.list.forEach((i) => {
        if (i.ThisPrice == '' || i.ThisPrice == null) {
          bool++;
        }
      });
      if (bool == this.list.length) {
        Toast('请先填写数据!');
        return;
      }
      if (this.ythflag == 1) {
        //退回并修改 4  //1蓝2绿3灰
        this.saveRow(0, '4');
      } else {
        this.saveRow(0, '2');
      }
    },
    shangbao() {
      //上报
      if (!this.ifCheckUpOk()) return;
      this.$dialog
        .confirm({
          message: '上报之后不能再进行修改，是否确认上报?'
        })
        .then(() => {
          this.saveRow(1, '5');
          //   this.upOK();
        })
        .catch(() => {});
    },
    // 点击商品名
    clickStoreName(item, index) {
      this.shopIndex = index;
      this.detailData = item;
      this.detailData.shopIndex1 = index + 1;
      let reason = rulesInfoDeal(item);
      if (reason.isWarn && reason.warnMsg) {
        this.detailData.placeholder = reason.warnMsg;
      } else {
        this.detailData.placeholder = '';
      }
      this.$refs.detailRef.initData(this.detailData);
    },
    //保存弹框信息
    saveBasic(row) {
      if (row.bqPrice > 99999999) {
        row.bqPrice = 99999999;
      } else if (row.bqPrice < 0) {
        row.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = row.bqPrice; //本期价格
      this.list[this.shopIndex].Memo = row.content; //说明
      this.list[this.shopIndex].comments = row.comments; //备注
      this.list[this.shopIndex].isGoods = row.isGoods ? 1 : 0; //无此品种
      this.list[this.shopIndex].importInfo = row.importInfo; //本期价格-字符
      this.$refs.listRef.changePrice('' ,this.shopIndex);
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.$refs.logRef.show();
      loading(true);
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
        taskId: this.taskID,
        exeNo: this.exeno,
        stationCode: this.StationCode
      }).then((res) => {
        this.logList = res.data;
        loading(false);
      });
    },
    //登陆状态监测 houcc 2021.07.24
    checkLogin() {
      checkLogin({}).then((res) => {
        if (!res.success) {
          // nativeJSBridge.logout();
          this.$router.push({ path: '/loginOld' });
        }
        this.loginStatus = res.success;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#caijixiangqing {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  .xinxi {
    padding-left: 0.363rem;
    padding-right: 0.1rem;
    padding-top: 0.3rem;
    padding-bottom: 0.1rem;
    width: calc(100vw - 0.463rem);
    min-height: 2.1rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
    margin-bottom: 0.2rem;
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: 'Microsoft YaHei', 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
      content: '';
      width: 0.02rem;
      height: 0.6rem;
      background: #ababab;
      position: absolute;
      right: 0;
    }
    v-button.btn2::after {
      content: '';
      width: 0rem;
      height: 0rem;
      // background: #ababab;
      // position: absolute;
      // right: 0;
    }
  }
  //提交上报的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
    .btn1 {
      font-weight: 400;
      color: #ababab;
    }
  }
  /deep/.van-cell {
    padding: 5px 16px;
    line-height: 0.9rem !important;
  }
  .twoTitle {
    color: #666666;
  }
  .twoLine {
    color: #020202;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 0.48rem;
    /deep/.van-button {
      padding: 0;
      margin: 0;
      height: 0.63333rem;
      line-height: 00.63333rem;
    }
  }
  .text-box {
    color: #ff6f00;
    font-family: PingFang SC;
    font-size: px2rem(38);
    padding: 0 0.05rem;
    letter-spacing: 0px;
    text-align: center;
    white-space: nowrap;
  }
}
.show-textarea {
  padding: 5px 16px;
  line-height: 0.9rem !important;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
  .show-textarea-title {
    width: 1.8rem !important;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
    font-size: 0.37037rem !important;
  }
  .show-textarea-con {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .long-txt {
      padding: 0px 0px !important;
    }
  }
}
</style>
